<script lang="ts">
  import Icon from "../../common/icons/Icon.svelte";

  export let title: string;
</script>

<div class="title">
  <div>{title}</div>
  <div><Icon icon="datadocs-logo" size="30px" /></div>
</div>

<style lang="postcss">
  .title {
    @apply flex flex-row items-center justify-between font-medium mb-4 text-dark-300 capitalize;
    font-size: 18px;
  }
</style>
